import React from 'react'
import { plainToInstance } from 'class-transformer'

import { Pagination } from '@components/Pagination'
import SelectPerPage from '@components/Pagination/components/SelectPerPage/SelectPerPage'
import { StoryCard } from '@components/StoryCard'
import { SearchRecommendType } from '@models/recommend/SearchRecommendType'
import StoryCardSkeleton from '@components/StoryCardSkeleton'
import NoData from '@components/NoData'
import { useDrawer } from '@hooks/contexts/DrawerContext/DrawerContext'
import { StoryDetailReaderType } from '@models/story/StoryDetailReaderType'
import { SearchResultProps } from './inteface'

const perPageOptions = [
  {
    label: '10',
    value: 10,
  },
  {
    label: '20',
    value: 20,
  },
  {
    label: '30',
    value: 30,
  },
]

function SearchResult({
  page,
  perpage,
  books,
  total,
  isLoading,
  isLoadingToggleBookLike,
  pageChange,
  perpageChange,
  handleLikeBook,
}: SearchResultProps) {
  const storyDrawer = useDrawer({ drawer: 'story' })

  return (
    <div className='tablet-mobile:px-[20px] tablet-mobile:my-[20px] desktop:mt-[10px]'>
      <div className='flex flex-row iems-center justify-between mb-[20px]'>
        <div className='flex items-center text-[14px] text-secondary-1 font-light'>
          <span className='mobile:hidden'>จำนวนงานเขียน : </span>
          <span
            className='text-secondary dark:text-dark-10 font-medium px-[5px]'
            data-test='total'
          >
            {total.toLocaleString()}
          </span>
          รายการ
        </div>
        <SelectPerPage
          value={perpage}
          options={perPageOptions}
          handleSelect={perpageChange}
        />
      </div>

      {isLoading ? (
        <div className='grid grid-cols-2 gap-[20px] mb-[30px] tablet:grid-cols-4'>
          {[...Array(2)].map((l, i) => (
            <StoryCardSkeleton key={i} direction='horizontal' />
          ))}
        </div>
      ) : books.length ? (
        <>
          <div
            className='grid grid-cols-2 gap-[20px] mb-[30px] tablet:grid-cols-4'
            data-test='search-result'
          >
            {books.map((story: SearchRecommendType) => (
              <StoryCard
                key={story.id}
                id={story.id}
                title={story.title}
                isShowBookPromotion={story.hasSalePromotions}
                buyAllChaptersPromotion={story.buyAllChaptersPromotion}
                readFreePromotion={story.readFreePromotion}
                bookChapterCampaignHeader={story.bookChapterCampaignHeader}
                bookBadges={story.bookBadges}
                imageUrl={story.coverResizeImgPath || story.coverImgPath}
                penName={story.penName?.firstPenName}
                slug={story.penName?.user?.profilePageSlug}
                content={story.cover}
                category={story.category?.name}
                tags={story.tags}
                chapter={story.chapterCount}
                view={story.viewCount}
                chat={story.commentCount}
                like={story.likeCount}
                isLiked={story.isLiked}
                isEnded={story.isEnded}
                bookType={story.bookType}
                isToggleBookLike={isLoadingToggleBookLike}
                handleLikeBook={handleLikeBook}
                categoryId={story.category?.id}
                handleClickStoryCard={() => {
                  storyDrawer.show({
                    bookId: story.id,
                    initialData: plainToInstance(StoryDetailReaderType, {
                      id: story.id,
                      coverImgPath: story.coverImgPath,
                      title: story.title,
                      writingType: story.writingType,
                      publishedAt: story.publishedAt,
                      cover: story.cover,
                      viewCount: story.viewCount,
                      commentCount: story.commentCount,
                      likeCount: story.likeCount,
                      publishedChapterCount: story.chapterCount,
                      penName: story.penName,
                      category: story.category,
                      bookType: story.bookType,
                      tags: story.tags,
                      rating: story.rating,
                      isEnded: story.isEnded,
                      isEpub: story.isEpub,
                      isPdf: story.isPdf,
                      isLiked: story.isLiked,
                    }),
                  })
                }}
              />
            ))}
          </div>
          <Pagination
            page={page}
            perpage={perpage}
            total={total}
            pageChange={pageChange}
          />
        </>
      ) : (
        <NoData />
      )}
    </div>
  )
}

export default SearchResult
